import "./Profile.css";
import {
  Avatar,
  Box,
  Button,
  Fab,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Input from "../../components/Common/Input/Input";
import { stringAvatar } from "../../helpers/stringAvatar";
import { getAuth, onAuthStateChanged, updateProfile } from "firebase/auth";
import { updateUser } from "../../controllers/auth/updateUser";
import profilePhoto from "../../assets/images/profile/1.png";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";

// Form Validate imports Start
import { isValidPhoneNumber } from "react-phone-number-input";
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form";
import { useForm } from "react-hook-form";
import { ProfileSchema } from "../../schemas";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
// Form Validate imports End
import { ToastContainer } from "react-toastify";

import OTPModal from "./OTPModal/OTPModal";
import NewPasswordModal from "./NewPasswordModal/NewPasswordModal";

import { useRef } from "react";
import {
  deleteObject,
  getDownloadURL,
  getStorage,
  listAll,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import useProfile from "./scripts/hook";
import { getLocalStorageItem } from "../../controllers/localStorage/getLocalStorage";
import useLogin from "../login/scripts/hook";
import UpdateDBUser from "../../controllers/users/UpdateDBUser";
import { db } from "../../firebase";
import { doc, getDoc, onSnapshot, setDoc, updateDoc } from "firebase/firestore";
import { ProfileStringAvatar } from "../../helpers/ProfileStringAvatar";

// Form Validate schema Start
const schema = yup.object().shape({
  name: yup
    .string()
    .min(3, "Name must have at least 3 characters")
    .max(30, "Name must not be more than 30 characters")
    .required("Name is required"),
  email: yup.string().email("Invalid email").default(""),
  businessContactNumber: yup
    .string()
    .required("Phone number is required")
    .nullable(),
  businessName: yup
    .string()
    .min(3, "Business name must have at least 3 characters")
    .max(30, "Business name must not be more than 30 characters")
    .required("Business name is required"),
  password: yup.string().test({
    name: "is-pass-required",
    skipAbsent: true,
    test(value, ctx) {
      if (this.parent.email !== "") {
        if (value.length < 6)
          return ctx.createError({
            message: "Password length must be greater than 6",
          });
      }
      return true;
    },
  }),

  confirmPassword: yup.string().test({
    name: "is-pass-matched",
    skipAbsent: true,
    test(value, ctx) {
      if (this.parent.email !== "") {
        if (value !== this.parent.password)
          return ctx.createError({
            message: "Password not matched",
          });
      }
      return true;
    },
  }),
});
// Form Validate schema End

const Profile = () => {
  // Form Validate const Start
  // const { control } = useForm({ amount: 0 });
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    setError,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });
  // Form Validate const End

  const navigate = useNavigate();
  const [isDisabled, setIsDisabled] = useState(false);
  const [ProfileData, setProfileData] = useState({});
  const [ClientName, setClientName] = useState(null);
  const [ClientPhone, setClientPhone] = useState(null);
  const [InputImage, setInputImage] = useState("");
  const [ListedImage, setListedImage] = useState({});
  const [Logo_, setLogo_] = useState("");
  const [Logo, setLogo] = useState({});
  // const [PassModal, setPassModal] = useState(false);
  const [Pass, setPass] = useState("");
  const [OTP, setOTP] = useState("");
  const [IsImageUploading, setIsImageUploading] = useState(false);

  const [isUserAgent, setIsUserAgent] = useState(false);

  const [
    PhoneAuthHandler,
    PhoneVerification,
    setPhoneVerification,
    AuthState,
    setAuthState,
    RegisterUsingPhoneNumber,
    RegisterButtonRef,
    CodeSent,
    setCodeSent,
    VerifyCode,
    Error,
    // setError,
    Code,
    setCode,
    ButtonLoader,
    goBack,
    PhoneError,
    ResendCode,
    _ResendCode,
  ] = useLogin();

  const [
    User,
    Client,
    CurrentAuth,
    ProfileImage,
    BusinessLogo,
    triggerUpdateProfile,
    handleProfileImageChange,
    handleBusinessLogoChange,
    updateProfile,
    resendEmail,
    VerifyPhoneNumber,
    setPhone,
    Phone,
  ] = useProfile();

  console.log("BusinessLogo", BusinessLogo);

  const [ProfileLoader, setProfileLoader] = useState(false);
  const [LogoLoader, setLogoLoader] = useState(false);
  const [Saving, setSaving] = useState(false);

  const [PasswordVisibility, setPasswordVisibility] = useState(false);
  const [ConfirmPasswordVisibility, setConfirmPasswordVisibility] =
    useState(false);

  // Handle Open File Start
  const fileUpload = useRef(null);
  const fileUpload2 = useRef(null);
  const handleUpload = (e) => {
    e.preventDefault();
    // document.getElementById("profileImageInput").click();
    fileUpload.current.click();
  };
  const handleUploadLogo = (e) => {
    e.preventDefault();
    fileUpload2.current.click();
  };
  // Handle Open File End

  /* Insert Business Logo------------------------------------------- */
  useEffect(() => {
    async function fetchData() {
      try {
        if (Logo_ === "") return;
        setLogoLoader(true);
        const __ext = Logo_.name.split(".").pop();
        const id = getLocalStorageItem("bid");
        const storage = getStorage();
        const storagePath = `business_logo/${id}/business.${__ext}`;

        const storageRef = ref(storage, storagePath);
        const uploadTask = uploadBytesResumable(storageRef, Logo_);

        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          },
          (error) => {
            console.log(error);
          },
          () => {
            getDownloadURL(uploadTask.snapshot.ref).then(
              async (downloadURL) => {
                await updateDoc(
                  doc(db, "clients", getLocalStorageItem("bid")),
                  {
                    image_url: downloadURL,
                  }
                );
                setLogoLoader(false);
              }
            );
          }
        );
      } catch (error) {
        throw error;
      }
    }
    fetchData();
  }, [Logo_]);

  // const uploadBusinessLogo = async () => {
  //   try {
  //     setLogoLoader(true);
  //     setIsImageUploading(true);
  //     const __ext = Logo_.name.split(".").pop();
  //     const id = getLocalStorageItem("bid");
  //     const storage = getStorage();
  //     const storagePath = `business_logo/${id}/business.${__ext}`;

  //     const storageRef = ref(storage, storagePath);
  //     const uploadTask = uploadBytesResumable(storageRef, Logo_);

  //     uploadTask.on(
  //       "state_changed",
  //       (snapshot) => {
  //         setLogoLoader(true);
  //         console.log("snapshot", snapshot);
  //         const progress =
  //           (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
  //         console.log("Upload is " + progress + "% done");
  //         setLogoLoader(false);
  //       },
  //       (error) => {
  //         console.log(error);
  //       },
  //       () => {
  //         getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
  //           console.log("File available at", downloadURL);
  //           await updateDoc(doc(db, "clients", getLocalStorageItem("bid")), {
  //             image_url: downloadURL,
  //           });
  //         });
  //       }
  //     );
  //     setLogoLoader(false);
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  // useEffect(() => {
  //   if (Logo_ === "") return;
  //   uploadBusinessLogo();
  // }, [Logo_]);

  // Upload Images Start
  // const uploadLogo = async () => {
  //   setLogoLoader(true);
  //   setIsImageUploading(true);
  //   const __ext = Logo_.name.split(".").pop();
  //   const id = getLocalStorageItem("bid");
  //   const __path = ref(getStorage(), `business_logo/${id}/business.${__ext}`);

  //   await listAll(
  //     ref(getStorage(), `business_logo/${getLocalStorageItem("bid")}`)
  //   )
  //     .then(async ({ prefixes, items }) => {
  //       for (let index = 0; index < items.length; index++)
  //         await deleteObject(items[index]);
  //     })
  //     .catch(() => console.log("error"));

  //   await uploadBytes(__path, Logo_).then(async (snapshot) => {
  //     console.log("uploadLogo", snapshot);
  //     listImages();
  //   });
  //   setLogoLoader(false);
  // };

  useEffect(() => {}, [LogoLoader]);
  useEffect(() => {}, [ProfileLoader]);
  useEffect(() => {}, [Saving]);
  // useEffect(() => setLogoLoader(false), []);
  // useEffect(() => setProfileLoader(false), []);
  useEffect(() => setSaving(false), []);

  // useEffect(() => {
  //   if (Logo_ === "") return;
  //   uploadLogo();
  // }, [Logo_]);
  // Upload Images End

  /* Insert Profile Image ------------------------------------------- */

  useEffect(() => {
    async function fetchData() {
      try {
        if (InputImage === "") return;
        setProfileLoader(true);
        getAuth().onAuthStateChanged(async () => {
          setIsImageUploading(true);
          const __ext = InputImage.name.split(".").pop();
          const id = getAuth().currentUser.uid;
          const storage = getStorage();
          const storagePath = `profile_images/${id}/original.${__ext}`;

          const storageRef = ref(storage, storagePath);
          const uploadTask = uploadBytesResumable(storageRef, InputImage);

          uploadTask.on(
            "state_changed",
            (snapshot) => {
              const progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            },
            (error) => {
              console.log(error);
            },
            () => {
              getDownloadURL(uploadTask.snapshot.ref).then(
                async (downloadURL) => {
                  getAuth().onAuthStateChanged(async () => {
                    const userId = getAuth().currentUser.uid;
                    await updateDoc(doc(db, "users", userId), {
                      image_url: downloadURL,
                    });

                    setProfileLoader(false);
                  });
                }
              );
            }
          );

          // setProfileLoader(false);
        });
      } catch (error) {
        console.log(error);
        throw error;
      }
    }
    fetchData();
  }, [InputImage]);

  // const uploadProfileImages = async () => {
  //   try {
  //     setProfileLoader(true);
  //     console.log("Function Call", 0);
  //     setIsImageUploading(true);
  //     const __ext = InputImage.name.split(".").pop();
  //     const id = getAuth().currentUser.uid;
  //     console.log("busniess_id", id);
  //     const storage = getStorage();
  //     const storagePath = `profile_images/${id}/original.${__ext}`;

  //     const storageRef = ref(storage, storagePath);
  //     const uploadTask = uploadBytesResumable(storageRef, InputImage);

  //     uploadTask.on(
  //       "state_changed",
  //       (snapshot) => {
  //         const progress =
  //           (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
  //         console.log("Upload is " + progress + "% done");
  //       },
  //       (error) => {
  //         console.log(error);
  //       },
  //       () => {
  //         getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
  //           console.log("File available at", downloadURL);
  //           getAuth().onAuthStateChanged(async () => {
  //           const userId = getAuth().currentUser.uid;
  //           await updateDoc(doc(db, "users", userId), {
  //             image_url: downloadURL,
  //           });
  //           });
  //         });
  //       }
  //     );

  //     console.log("Function Call", 1);
  //     setProfileLoader(false);
  //   } catch (error) {
  //     console.log(error);
  //     throw error;
  //   }
  // };

  // useEffect(() => {
  //   if (InputImage === "") return;
  //   uploadProfileImages();
  // }, [InputImage]);

  // Upload Images Start
  // const uploadImages = async () => {
  //   setProfileLoader(true);
  //   setIsImageUploading(true);

  //   const __ext = InputImage.name.split(".").pop();
  //   const id = getAuth().currentUser.uid;
  //   const __path = ref(getStorage(), `profile_images/${id}/original.${__ext}`);

  //   await listAll(ref(getStorage(), `profile_images/${id}`))
  //     .then(async ({ prefixes, items }) => {
  //       for (let index = 0; index < items.length; index++)
  //         await deleteObject(items[index]);
  //     })
  //     .catch(() => console.log("error"));

  //   await uploadBytes(__path, InputImage).then(async (snapshot) => {
  //     console.log("uploadImages", snapshot);
  //     listImages();
  //   });
  //   setProfileLoader(false);
  // };

  // useEffect(() => {
  //   if (InputImage === "") return;
  //   uploadImages();
  // }, [InputImage]);
  // Upload Images End

  // List Images Start
  // const getProfileImage = async () => {
  //   await getAuth().onAuthStateChanged(async () => {
  //     const id = getAuth().currentUser.uid;

  //     listAll(ref(getStorage(), `profile_images/${id}`))
  //       .then(async ({ prefixes, items }) => {
  //         console.log("image_url", await getDownloadURL(items[0]));
  //         setListedImage(await getDownloadURL(items[0]));
  //         setIsImageUploading(false);
  //       })
  //       .catch(async () => {
  //         setIsImageUploading(false);
  //       });
  //   });
  // };

  useEffect(() => {
    getAuth().onAuthStateChanged(() => {
      const user = getAuth().currentUser;
      setProfileData(user);
    });
  }, []);

  // useEffect(() => {
  //   async function fetchData() {
  //     getAuth().onAuthStateChanged(async () => {
  //       console.log("userDocument", 2);
  //       const userId = getAuth().currentUser.uid;
  //       console.log("userDocument", 3);
  //       const userDocument = await doc(db, "users", userId);
  //       console.log("userDocument", 4);
  //       const userSnapshot = await getDoc(userDocument);
  //       const user = { id: userSnapshot.id, ...userSnapshot.data() };
  //       console.log("userDocument", user);
  //       setProfileData(user);
  //     });
  //   }
  //   console.log("userDocument", 1);
  //   fetchData();
  // }, []);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async () => {
        const userId = getAuth().currentUser.uid;
        onSnapshot(doc(db, "users", userId), (doc) => {
          const userDoc = doc.data();
          setProfileData(userDoc);
        });
      });
    }
    fetchData();
  }, []);

  /* Fetch Profile Data ------------------------------------------- */
  useEffect(() => {
    async function fetchData() {
      const userId = getAuth().currentUser.uid;
      onSnapshot(doc(db, "users", userId), (doc) => {
        const userDoc = doc.data();
        if (userDoc.role === "agent") {
          setIsUserAgent(true);
        } else {
          setIsUserAgent(false);
        }
        if (JSON.stringify(userDoc) === JSON.stringify({})) {
          return;
        } else {
          setProfileData(userDoc);
        }
      });
    }
    fetchData();
  }, []);

  /* Fetch Profile Image ------------------------------------------- */
  // useEffect(() => {
  //   async function fetchData() {
  //     const id = getAuth().currentUser.uid;
  //     await onSnapshot(doc(db, "users", id), (doc) => {
  //       setListedImage(doc.data());
  //     });
  //   }
  //   fetchData();
  // }, []);

  // const getLogo = async () => {
  //   await getAuth().onAuthStateChanged(async () => {
  //     const id = getAuth().currentUser.uid;

  //     listAll(ref(getStorage(), `business_logo/${getLocalStorageItem("bid")}`))
  //       .then(async ({ prefixes, items }) => {
  //         setLogo(await getDownloadURL(items[0]));
  //         setIsImageUploading(false);
  //       })
  //       .catch(async () => {
  //         setIsImageUploading(false);
  //       });
  //   });
  // };

  /* Fetch Profile Image ------------------------------------------- */
  useEffect(() => {
    async function fetchData() {
      const clientDocument = await doc(
        db,
        "clients",
        getLocalStorageItem("bid")
      );
      const clientSnapshot = await getDoc(clientDocument);
      const client = { id: clientSnapshot.id, ...clientSnapshot.data() };
      setLogo(client);
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      await onSnapshot(
        doc(db, "clients", getLocalStorageItem("bid")),
        (doc) => {
          setLogo(doc.data());
        }
      );
    }
    fetchData();
  }, []);

  // const listImages = async () => {
  // setIsImageUploading(true);
  // await getProfileImage();
  // await getLogo();
  // setIsImageUploading(false);
  // };

  const [__email, set__email] = useState("");
  const [__password, set__password] = useState("");
  useEffect(() => set__email(watch("email")), [watch("email")]);
  useEffect(() => set__password(watch("password")), [watch("password")]);

  // useEffect(() => {
  //   listImages();
  // }, []);
  // List Images End

  // Handle Submit Start
  const _submitForm = async (e) => {
    setSaving(true);
    setIsDisabled(true);
    if (!User?.verified_email && watch("email") !== "") {
      // setPassModal(true);

      await updateProfile(watch());
      setOTP_Modal(true);
      setPhone(watch("phone"));
      // ResendCode();
    } else {
      // submitForm(watch());
      await updateProfile(watch());
      window.location.pathname = "/user/dashboard";
    }

    setSaving(false);
    setIsDisabled(false);
  };

  // useEffect(() => {
  //   setValue("name", CurrentAuth?.displayName);
  //   setValue("phone", CurrentAuth?.phoneNumber);
  //   setValue("email", CurrentAuth?.email);
  //   setValue("businessName", Client?.businessName);
  // }, []);

  const submitForm = async (e) => {
    setSaving(true);
    setIsDisabled(true);
    if (!User?.verified_email && watch("email") !== "") {
      // setPassModal(true);

      await updateProfile(watch());
      setOTP_Modal(true);
      setPhone(watch("phone"));
      // ResendCode();
      VerifyPhoneNumber();
    } else {
      if (
        watch("businessContactNumber") !== "" ||
        watch("businessContactNumber") !== null ||
        watch("businessContactNumber") !== undefined
      ) {
        if (!isValidPhoneNumber(watch("businessContactNumber"))) {
          setError("businessContactNumber", {
            message: "Enter a valid phone number",
          });
          setSaving(false);
          setIsDisabled(false);
          return;
        }
      }
      console.log(watch());
      // submitForm(watch());
      await updateProfile(watch());
      // window.location.pathname = "/user/dashboard";
      navigate("/user/dashboard");
    }

    setSaving(false);
    setIsDisabled(false);
  };
  // const submitForm = async (e) => {
  //   // e.preventDefault();
  //   if (!User?.verified_email && watch("email") !== "") return;

  //   setSaving(true);
  //   console.log(e);
  //   setIsDisabled(true);
  //   await updateUser({
  //     displayName: e.name,
  //     email: e.email,
  //     password: Pass,
  //     OTP,
  //   });

  //   const PhoneNumber = getAuth()?.currentUser?.phoneNumber;
  //   const NewName = e.name;
  //   await UpdateDBUser(NewName, PhoneNumber);

  //   // if (Pass !== "") navigate("/verify/email");
  //   console.log("trigering update profile....");
  //   await triggerUpdateProfile(e)
  //     .then(() => {
  //       console.log("called update profile....");
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //     });

  //   setIsDisabled(false);
  //   setSaving(false);

  //   // navigate("/user/dashboard", { replace: true });
  //   // window.location.pathname = "/user/dashboard";
  // };
  // Handle Submit End

  const [OTP_Modal, setOTP_Modal] = useState(false);
  const [PassModal, setPassModal] = useState(false);

  // const proceedToOTPModal = () => {
  //   setOTP_Modal(true);
  // };
  const proceedToOTPModal = () => {
    setOTP_Modal(true);
    setPassModal(false);
  };
  const proceedToPassModal = () => {
    setOTP_Modal(false);
    setPassModal(true);
  };
  const closeModals = () => {
    setOTP_Modal(false);
    setPassModal(false);
  };
  const getData = () => {
    return {
      name: watch("name"),
      email: watch("email"),
      password: watch("password"),
    };
  };

  const formRef = useRef();

  return (
    <Fragment>
      {/* <Modal
        open={PassModal}
        onClose={() => setPassModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="m-auto p-5 bg-white w-25">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Link Email With your account
          </Typography>
          <TextField
            id="outlined-basic"
            label="OTP"
            variant="outlined"
            onChange={(e) => setOTP(e.target.value)}
            value={OTP}
          />
          <TextField
            id="outlined-basic"
            label="Password"
            variant="outlined"
            onChange={(e) => setPass(e.target.value)}
            value={Pass}
          />
          <button onClick={() => submitForm(watch())}>Link Email</button>
        </Box>
      </Modal> */}
      {CurrentAuth && (
        // <form ref={formRef} onSubmit={handleSubmit(submitForm)}>
        <form onSubmit={handleSubmit(submitForm)}>
          <div className="global-body-container app-profile-page">
            <div className="profile-page-header">
              <div className="profile-page-back-btn">
                <button
                  type="button"
                  onClick={() => navigate(-1)}
                  className="custom-back-btn"
                >
                  <ArrowBackIosRoundedIcon className="custom-back-btn-icon" />
                  <span>Back</span>
                </button>
              </div>

              <div className="profile-page-heading d-lg-block">
                <h2 className="custom-heading">Profile</h2>
              </div>
              <NewPasswordModal
                {...{
                  PassModal,
                  proceedToOTPModal,
                  closeModals,
                  setPass,
                }}
              />
              <OTPModal
                {...{
                  OTP_Modal,
                  proceedToPassModal,
                  closeModals,
                  phoneNo: Phone,
                  getData,
                  resendEmail,
                  __email,
                  __password,
                }}
              />
            </div>
            <div className="row">
              <div className="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12">
                <div className="profile-content-container">
                  <div className="profile-photo-container">
                    <h2
                      className="custom-heading custom-m4 mb-3"
                      style={{
                        marginLeft: 13,
                      }}
                    >
                      Profile Settings
                    </h2>
                    <p className="custom-label custom-m4 custom-label">
                      Profile Photo
                    </p>
                    <div className="content">
                      {/* {!IsImageUploading && ListedImage === "" && (
                          <Avatar
                            {...stringAvatar(ProfileData?.displayName)}
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "50%",
                            }}
                          />
                        )} */}
                      {/* {ListedImage !== "" && (
                          <img src={ListedImage.image_url} alt="" />
                        )} */}

                      {ProfileData.image_url && (
                        <div
                          className="profile-logo"
                          style={{
                            backgroundImage: `url(${ProfileData.image_url})`,
                          }}
                        ></div>
                      )}

                      {!ProfileData.image_url && ProfileData.name && (
                        <Avatar
                          className="profile-image"
                          {...stringAvatar(ProfileData.name)}
                        />
                      )}

                      {!ProfileData.image_url &&
                        !ProfileData.name &&
                        ProfileData.phoneNumber && (
                          <Avatar
                            className="profile-image"
                            {...stringAvatar("Profile Photo")}
                          />
                        )}
                      {/* <img src={profilePhoto} alt="" /> */}
                      <div className="content-button">
                        <input
                          type="file"
                          ref={fileUpload}
                          onChange={(e) => setInputImage(e.target.files[0])}
                          className="my_file"
                          id="profileImageInput"
                          accept="image/png, image/jpeg"
                        />
                        <button
                          className="d-flex custom-label"
                          onClick={handleUpload}
                          // onChange={handleProfileImageChange}
                          disabled={ProfileLoader}
                        >
                          Upload Photo
                          {ProfileLoader && (
                            <div
                              className="spinner-border"
                              style={{
                                width: 15,
                                height: 15,
                                marginLeft: 10,
                              }}
                            ></div>
                          )}
                        </button>
                        <p
                          style={{
                            marginLeft: 1,
                          }}
                        >
                          At least 256 X 256px PNG or JPG file
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="profile-form-container">
                    {/* <form
                    className="modal-body"
                    onSubmit={handleSubmit(submitForm)}
                    > */}
                    <div className="form-row profile-form-row">
                      <div className="form-group col-12">
                        <label className="form-field-label custom-m4">
                          Full Name <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          name="name"
                          // required
                          className="form-control form-input-field custom-m4"
                          {...register("name")}
                          disabled={isDisabled}
                          // value={CurrentAuth?.displayName}
                          // defaultValue={CurrentAuth?.displayName}
                          defaultValue={CurrentAuth?.name}
                        />
                        <p className="errorMessage custom-m4">
                          {" "}
                          {errors.name?.message}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group col-12">
                        <label className="form-field-label custom-m4">
                          Email
                        </label>
                        <input
                          type="text"
                          name="email"
                          onFocus={(e) => (e.target.type = "email")}
                          className="form-control form-input-field custom-m4 "
                          {...register("email")}
                          disabled={
                            isDisabled ||
                            (getAuth()?.currentUser?.email?.length || 0) > 0 ||
                            User?.verified_email
                          }
                          defaultValue={CurrentAuth?.email}
                        />
                        <p className="profile-page-error-message custom-m4">
                          {" "}
                          {errors.email?.message}{" "}
                        </p>
                      </div>
                    </div>

                    {watch("email") !== "" &&
                      (getAuth()?.currentUser?.email?.length || 0) === 0 &&
                      !User?.verified_email &&
                      !("email" in errors) && (
                        <>
                          <div className="form-row">
                            <div className="form-group col-12">
                              <p className="custom-label custom-m4">
                                Password <span style={{ color: "red" }}>*</span>
                              </p>
                              <input
                                type={PasswordVisibility ? "text" : "password"}
                                name="password"
                                id="password"
                                className="input-style custom-m4 custom-field-content"
                                {...register("password")}
                                disabled={isDisabled}
                              />
                              <span
                                style={{
                                  right: 28,
                                  top: 34,
                                  fontSize: 20,
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  setPasswordVisibility(!PasswordVisibility)
                                }
                                className={`position-absolute text-muted loginOpenCloseEyeIcon ${
                                  PasswordVisibility
                                    ? "bi bi-eye-fill"
                                    : "bi bi-eye-slash-fill"
                                } `}
                              ></span>
                              <p className="profile-page-error-message custom-m4">
                                {" "}
                                {errors?.password?.message}{" "}
                              </p>
                            </div>
                          </div>

                          <div className="form-row">
                            <div className="form-group col-12">
                              <p className="custom-label custom-m4">
                                Confirm Password{" "}
                                <span style={{ color: "red" }}>*</span>
                              </p>
                              <input
                                type={
                                  ConfirmPasswordVisibility
                                    ? "text"
                                    : "password"
                                }
                                name="confirmPassword"
                                id="confirmPassword"
                                className="input-style custom-m4 custom-field-content"
                                {...register("confirmPassword")}
                                disabled={isDisabled}
                              />
                              <span
                                style={{
                                  right: 28,
                                  top: 34,
                                  fontSize: 20,
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  setConfirmPasswordVisibility(
                                    !ConfirmPasswordVisibility
                                  )
                                }
                                className={`position-absolute text-muted loginOpenCloseEyeIcon ${
                                  ConfirmPasswordVisibility
                                    ? "bi bi-eye-fill"
                                    : "bi bi-eye-slash-fill"
                                } `}
                              ></span>
                              <p className="profile-page-error-message custom-m4">
                                {" "}
                                {errors?.confirmPassword?.message}{" "}
                              </p>
                            </div>
                          </div>
                        </>
                      )}

                    <div className="form-row">
                      <div className="form-group col-12">
                        <label className="form-field-label custom-m4">
                          Phone Number <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          name="phone"
                          // placeholder="XXXX XXXXXXX"
                          // data-inputmask="'mask': '9999 9999999'"
                          className="input-style custom-m4 custom-field-content"
                          // pattern="^[0-9]{4} [0-9]{7}$"
                          // required
                          id="phone"
                          // value={PhoneNumber}
                          disabled={true}
                          {...register("phone")}
                          defaultValue={CurrentAuth?.phoneNumber}
                          // onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                        <p className="profile-page-error-message custom-m4">
                          {" "}
                          {errors?.phoneNumber?.message}{" "}
                        </p>
                      </div>
                    </div>
                    {/* </form> */}
                    <hr className="profile-divider" />
                    <div className="business-profile-container">
                      <h2
                        className="custom-heading custom-m4"
                        style={{
                          marginLeft: 13,
                        }}
                      >
                        Business Profile Settings
                      </h2>
                      {Client && (
                        <Fragment>
                          <div className="business-logo-container">
                            {/* <form> */}
                            <div className="form-row">
                              <div className="form-group col-12">
                                <div className="business-logo-container">
                                  <p
                                    className="custom-label"
                                    style={{
                                      marginBottom: 5,
                                    }}
                                  >
                                    Business Logo{" "}
                                    {/* <span style={{ color: "red" }}>*</span> */}
                                  </p>
                                  <div className="content">
                                    {!Logo?.image_url && Logo?.businessName && (
                                      <Avatar
                                        className="profile-business-avatar"
                                        {...stringAvatar(Logo?.businessName)}
                                      />
                                    )}

                                    {!Logo?.businessName &&
                                      !Logo?.image_url && (
                                        <Avatar
                                          className="profile-business-avatar"
                                          {...stringAvatar("Business Logo")}
                                        />
                                      )}

                                    {Logo?.image_url && (
                                      <div
                                        className="business-logo"
                                        style={{
                                          backgroundImage: `url(${Logo?.image_url})`,
                                        }}
                                      ></div>
                                    )}
                                    {!isUserAgent && (
                                      <div className="content-button">
                                        <input
                                          type="file"
                                          disabled={isUserAgent}
                                          ref={fileUpload2}
                                          onChange={(e) =>
                                            setLogo_(e.target.files[0])
                                          }
                                          className="my_file"
                                          accept="image/png, image/jpeg"
                                        />
                                        <button
                                          className="d-flex custom-label"
                                          onClick={handleUploadLogo}
                                          onChange={handleBusinessLogoChange}
                                          disabled={LogoLoader || isUserAgent}
                                        >
                                          Upload Photo
                                          {LogoLoader && (
                                            <div
                                              className="spinner-border"
                                              style={{
                                                width: 15,
                                                height: 15,
                                                marginLeft: 10,
                                              }}
                                            ></div>
                                          )}
                                        </button>
                                        <p
                                          style={{
                                            marginLeft: 1,
                                          }}
                                        >
                                          At least 256 X 256px PNG or JPG file
                                        </p>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* </form> */}
                          </div>
                          <div className="business-name-container">
                            {/* <form> */}
                            <div className="form-row">
                              <div className="form-group col-12">
                                <label className="form-field-label custom-m4">
                                  Business Name{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  // required
                                  name="businessName"
                                  className="form-control form-input-field custom-m4"
                                  {...register("businessName")}
                                  readOnly={isUserAgent}
                                  disabled={isDisabled}
                                  defaultValue={Client?.businessName}
                                />
                                <p className="profile-page-error-message custom-m4">
                                  {errors?.businessName?.message}
                                </p>
                              </div>
                            </div>
                            <div className="form-row">
                              <div className="form-group col-12">
                                <label className="form-field-label custom-m4">
                                  Business Contact Number{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <PhoneInputWithCountry
                                  name="businessContactNumber"
                                  className="form-phone-input-field custom-m4"
                                  defaultCountry={"PK"}
                                  international={true}
                                  countryCallingCodeEditable={false}
                                  initialValueFormat="national"
                                  control={control}
                                  readOnly={isUserAgent}
                                  disabled={isDisabled}
                                  defaultValue={
                                    Client?.businessContactNumber
                                      ? Client?.businessContactNumber
                                      : CurrentAuth?.phoneNumber
                                  }
                                  rules={{
                                    validate: (value) =>
                                      isValidPhoneNumber(value),
                                    required: true,
                                  }}
                                  style={{ border: "none !important" }}
                                />

                                <p className="profile-page-error-message custom-m4">
                                  {" "}
                                  {errors.businessContactNumber?.message}{" "}
                                </p>
                              </div>
                            </div>

                            {/* <div className="form-row">
                                <div className="form-group col-12">
                                  <label className="business-contact-number-input-label">
                                    Business Contact Number{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="businessContactNumber"
                                    className="form-control input-style"
                                    {...register("businessContactNumber")}
                                    defaultValue={
                                      Client?.businessContactNumber
                                        ? Client?.businessContactNumber
                                        : CurrentAuth?.phoneNumber
                                    }
                                    readOnly={isUserAgent}
                                    disabled={isDisabled}
                                  />
                                  <p className="profile-page-error-message custom-m4">
                                    {" "}
                                    {errors.businessContactNumber?.message}{" "}
                                  </p>
                                </div>
                              </div> */}
                            {/* <hr className="input-style" /> */}
                            <div className="modal-footer">
                              <input
                                type={"submit"}
                                style={{ display: "none" }}
                                id={"profile-hidden-btn"}
                              />

                              <button
                                type="submit"
                                className="form-submit-button py-2"
                                // onClick={async (e) => {
                                //   // e.preventDefault();
                                //   // handleSubmit(async () => {
                                //   //   setSaving(true);
                                //   //   setIsDisabled(true);
                                //   //   if (
                                //   //     !User?.verified_email &&
                                //   //     watch("email") !== ""
                                //   //   ) {
                                //   //     // setPassModal(true);
                                //   //     await updateProfile(watch());
                                //   //     setOTP_Modal(true);
                                //   //     setPhone(watch("phone"));
                                //   //     console.log("submit", watch());
                                //   //     // ResendCode();
                                //   //   } else {
                                //   //     console.log("submitting...");
                                //   //     // submitForm(watch());
                                //   //     await updateProfile(watch());
                                //   //     window.location.pathname =
                                //   //       "/user/dashboard";
                                //   //   }
                                //   //   setSaving(false);
                                //   //   setIsDisabled(false);
                                //   //   console.log(errors);
                                //   // });
                                // }}
                                disabled={LogoLoader || ProfileLoader || Saving}
                              >
                                {Saving && (
                                  <span className="spinner-border spinner-border-sm mr-1"></span>
                                )}
                                Save Changes
                              </button>
                            </div>
                            {/* </form> */}
                          </div>
                        </Fragment>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-4 col-xl-4 col-lg-0 col-md-0 col-sm-0"></div>
            </div>

            <Fragment>
              {/* {ProfileData && (
              <div className="col-12 col-xl-6 col-xxl-6 col-lg-6 col-md-12 pt-4 m-auto profilePageContent">
                <div className="card bg-box">
                  <div className="card-body">
                    <h4 className="card-title pt-1">Profile</h4>
                    <h5 className="card-text">
                      You can view and edit your profile
                    </h5>

                    <Fragment>
                      <form onSubmit={handleSubmit(submitForm)}>
                        <div className="row">
                          <div className="col-8">
                            <Input
                              label={"Name"}
                              name={"name"}
                              defaultValue={ProfileData?.displayName}
                              value={ClientName}
                              onChange={(e) => setClientName(e.target.value)}
                              register={{ ...register("name") }}
                              errors={errors}
                            />

                            <Input
                              label={"Email"}
                              name={"email"}
                              value={ProfileData.email}
                              disabled
                            />
                            <Input
                              label={"Phone"}
                              name={"phone"}
                              defaultValue={ProfileData?.phoneNumber}
                              value={ClientPhone}
                              onChange={(e) => setClientPhone(e.target.value)}
                              register={{ ...register("phone") }}
                              errors={errors}
                            />
                          </div>
                          <div className="col-4 avatar-container">
                            {!IsImageUploading && ListedImage === "" && (
                              <Avatar
                                {...stringAvatar(ProfileData.displayName)}
                                className="avatar-txt"
                              />
                            )}

                            {!IsImageUploading && ListedImage !== "" && (
                              <div
                                className="profileImage"
                                style={{
                                  backgroundImage: `url(${ListedImage})`,
                                }}
                              ></div>
                            )}

                            {IsImageUploading && (
                              <div className="loading">Loading...</div>
                            )}

                            <input
                              type="file"
                              ref={fileUpload}
                              onChange={(e) => setInputImage(e.target.files[0])}
                              className="my_file"
                            />
                            <button className="get_file" onClick={handleUpload}>
                              Change Image
                            </button>
                          </div>
                        </div>
                        <div>
                          <h4 className="text-black-50 my-2">
                            Email Verification:{" "}
                            {ProfileData.emailVerified && (
                              <span className="text-success">
                                Verified <i class="bi bi-check-all"></i>
                              </span>
                            )}
                            {!ProfileData.emailVerified && (
                              <span className="text-danger">
                                Not Verified <i class="bi bi-x-octagon"></i>
                              </span>
                            )}
                          </h4>
                          <Fab
                            variant="extended"
                            size="medium"
                            type="submit"
                            className="active-btn float-right"
                            disabled={isDisabled}
                          >
                            {isDisabled && (
                              <span className="spinner-border spinner-border-sm mr-1"></span>
                            )}
                            Save Update
                          </Fab>
                        </div>
                      </form>
                    </Fragment>
                  </div>
                </div>
              </div>
            )} */}
            </Fragment>
          </div>
        </form>
      )}
      <ToastContainer />
    </Fragment>
  );
};

export default Profile;
